<template>
  <div class="spin-button"
       role="spinbutton"
       :aria-valuemin="min"
       :aria-valuemax="max"
       :aria-valuenow="value"
       :tabindex="0"
       @keydown="onKeydown">

    <Button v-if="hideDecrement"
      preset-size
      class="p-2 px-3"
      @click.stop="$emit('edit')"
      :aria-label="$t(ariaLabel)"
      tabindex="-1"
      icon-left="pencil"
      :icon-only="true"
      :disabled="value === 0"
    />

    <Button v-if="!hideDecrement"
      preset-size
      class="p-2 px-3"
      @click.stop="decrement"
      :aria-label="$t(ariaLabel)"
      :disabled="value <= min"
      tabindex="-1"
      :icon-left="iconTypeOnDecrement"
      :icon-only="true"
    />

    <input
        type="number"
        :value="value"
        @input="onInput"
        :disabled="true"
        :min="min"
        :max="max"
        :aria-disabled="true"
        aria-valuemin="min"
        aria-valuemax="max"
        aria-valuenow="value"
        aria-label="$t('ariaLabel.quantity')"
    />

    <Button
      preset-size
      class="p-2 px-3"
      @click.stop="increment"
      aria-label="$t('ariaLabel.increaseItemQuantity')"
      :disabled="value >= max"
      tabindex="-1"
      icon-left="circle-plus"
      :icon-only="true"
    />
  </div>
</template>

<script>
import Button from '@/components/barrier-free-template-components/Button.vue';

export default {
  name: 'SpinButton',
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    hideDecrement: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button
  },
  data() {
    return {};
  },
  computed: {
    value() {
      return this.modelValue;
    },
    iconTypeOnDecrement() {
      if (this.value === 1) {
        return 'trash-can';
      }
      return 'circle-minus';
    },
    ariaLabel() {
      if (this.value > 0) {
        return this.hideDecrement ? 'ariaLabel.edit' : 'ariaLabel.removeItem';
      }
      return 'ariaLabel.decreaseItemQuantity';
    },
  },
  watch: {
    // Remove local value management, always use modelValue
  },
  methods: {
    increment() {
      // Always allow increment if value < max
      if (this.value < this.max) {
        const newValue = Math.min(this.value + this.step, this.max);
        this.$emit('update:modelValue', { value: newValue, type: 'increment' });
      }
    },
    decrement() {
      if (this.value > this.min) {
        const newValue = Math.max(this.value - this.step, this.min);
        this.$emit('update:modelValue', { value: newValue, type: 'decrement' });
      }
    },
    onKeydown(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowRight') {
        this.increment();
        e.preventDefault();
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') {
        this.decrement();
        e.preventDefault();
      }
    },
    onInput(e) {
      const newValue = parseInt(e.target.value, 10);
      if (!isNaN(newValue) && newValue >= this.min && newValue <= this.max) {
        this.$emit('update:modelValue', { value: newValue, type: 'input' });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.spin-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

input {
  text-align: center;
  width: 60px;
  padding: 5px;
  margin: 0 10px;
  font-size: 16px;
}

/*
button {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
*/

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
